import type { WidenLocale } from '@mangovoice/types'

export const userGroupsEn = {
  common: {
    cancel: `Cancel`,
    close: `Close`,
    delete: `Delete`,
    error: `Error`,
    yes: `Yes`,
    no: `No`,
    requirePin: `Require PIN`,
    pin: `PIN`,
    auto: `auto`,
  },
  list: {
    title: `User Groups`,
    searchPlaceholder: `Search by name or member...`,
    searchAriaLabel: `Search user groups`,
    createNew: `New User Group`,
    createNewAriaLabel: `Create new user group`,
    tableAriaLabel: `User groups table`,
    loading: `Loading user groups...`,
    noResultsTitle: `No results found`,
    noResultsDescription: `Try adjusting your search terms`,
    emptyTitle: `No user groups yet`,
    emptyDescription: `Get started by creating your first user group`,
    autoGeneratedDeleteTooltip: `Auto-generated groups cannot be deleted`,
    truncatedWarning: `Showing the first {{shown}} of {{total}} user groups. Some groups are not listed — please contact support.`,
    actionsForGroup: `Actions for {{name}}`,
    editGroup: `Edit {{name}}`,
    deleteGroup: `Delete {{name}}`,
    deleteGroupDisabled: `Delete {{name}} (disabled)`,
    accessAria: `{{label}}: {{status}}`,
    column: {
      name: `Name`,
      members: `Members`,
      internal: `Internal`,
      local: `Local`,
      longDistance: `Long Dist.`,
      domesticLongDistance: `Long distance`,
      international: `International`,
      action: `Action`,
    },
    pagination: {
      perPage: `Per page:`,
      total: `({{count}} total)`,
      resultsPerPage: `Results per page`,
      previousPage: `Previous page`,
      nextPage: `Next page`,
      jumpToPage: `Jump to page {{page}}`,
      morePages: `More pages`,
    },
    deleteDialog: {
      title: `Delete User Group`,
      description: `Are you sure you want to delete "{{name}}"? This will remove all member associations and cannot be undone.`,
      successTitle: `User group deleted`,
      successDescription: `"{{name}}" has been deleted.`,
      alreadyDeletedTitle: `Already deleted`,
      alreadyDeletedDescription: `This user group was not found - it may have already been deleted.`,
      failedDescription: `Failed to delete user group.`,
    },
  },
  form: {
    addTitle: `Add User Group`,
    editTitle: `Edit User Group`,
    loading: `Loading user group...`,
    loadingError: `Error loading user group: {{message}}`,
    autoGeneratedNotice: `Auto-generated group - some fields are restricted.`,
    nameLabel: `Name`,
    namePlaceholder: `Enter group name`,
    nameRequired: `Name is required.`,
    nameMaxLength: `Name must be 64 characters or less.`,
    accessPermissions: `Access Permissions`,
    members: `Members`,
    createUserGroup: `Create User Group`,
    saveChanges: `Save Changes`,
    access: {
      internal: `Internal`,
      local: `Local`,
      domesticLongDistance: `Domestic Long Distance`,
      international: `International`,
      tollNumbers: `Toll Numbers`,
      maliciousAreaCodes: `Malicious Area Codes`,
      superAccess: `Super Access`,
      eavesdropping: `Eavesdropping`,
      promptRecording: `Prompt Recording`,
    },
    memberPicker: {
      placeholder: `Select members...`,
      searchPlaceholder: `Filter members...`,
      emptyLabel: `No users assigned to this PBX.`,
      noResultsLabel: `No users match your filter.`,
      summary_one: `{{count}} member selected`,
      summary_other: `{{count}} members selected`,
    },
  },
  toast: {
    createdTitle: `User group created`,
    updatedTitle: `User group updated`,
    authRequiredTitle: `Authentication required`,
    authRequiredDescription: `Your session may have expired. Please re-authenticate and try again.`,
    createFailedTitle: `Failed to create user group`,
    updateFailedTitle: `Failed to update user group`,
  },
}

export type UserGroupsLocale = WidenLocale<typeof userGroupsEn>
